import { render, staticRenderFns } from "./AccessControlNew.vue?vue&type=template&id=711124fc&scoped=true"
import script from "./AccessControlNew.vue?vue&type=script&lang=js"
export * from "./AccessControlNew.vue?vue&type=script&lang=js"
import style0 from "./AccessControlNew.vue?vue&type=style&index=0&id=711124fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711124fc",
  null
  
)

export default component.exports